<template>
  <v-card
    flat
    class="my-3"
    tile
  >
  <v-list :class=baseColor class="pa-4 text-left" dense>
    <h3 :class=risultato> {{ question.question }} </h3>
      <v-list-item
        :class=rigaA
      >
      <v-list-item-icon>
        <v-avatar 
          dark :color=baseColor size="25"> 
          <span class="headline">A</span>
        </v-avatar>
      </v-list-item-icon>
      <v-list-item-content :class=testoA>
        {{ question.options[0] }}
      </v-list-item-content>
      </v-list-item>
      <v-list-item
        :class=rigaB
      >
        <v-list-item-icon>
          <v-avatar 
            dark :color=baseColor size="25"> 
            <span class="headline">B</span>
          </v-avatar>
        </v-list-item-icon>
        <v-list-item-content :class=testoB>
          {{ question.options[1] }}
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :class=rigaC
      >
        <v-list-item-icon>
          <v-avatar 
            dark :color=baseColor size="25"> 
            <span class="headline">C</span>
          </v-avatar>
        </v-list-item-icon>
        <v-list-item-content :class=testoC>
          {{ question.options[2] }}
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
  export default {
    name: 'Rispostamultiplacheck',
    data: () => ({
      selectedItem: null,
      baseColor: 'grey lighten-3',
    }),
    computed: {
      verifica() {
        return (parseInt(this.answered)===this.question.right)
      },
      risultato() {
        return this.verifica ? 'pa-1 white green--text' : 'pa-1 white red--text'
      },
      icona() {
        return this.verifica ? 'mdi-thumb-up-outline' : 'mdi-thumb-down-outline'
      },
      rigaA() {
        if (this.verifica) return this.question.right===0 ? 'green' : this.baseColor
        else return this.question.right===0 ? this.baseColor : parseInt(this.answered)===0 ? 'red' : this.baseColor
      },
      testoA() {
        if (this.verifica) return this.question.right===0 ? 'white--text font-weight-bold' : 'black--text'
        else return this.question.right===0 ? 'green--text font-weight-bold' : parseInt(this.answered)===0 ? 'white--text font-weight-bold' : 'black--text'
      },
      rigaB() {
        if (this.verifica) return this.question.right===1 ? 'green' : this.baseColor
        else return this.question.right===1 ? this.baseColor : parseInt(this.answered)===1 ? 'red' : this.baseColor
      },
      testoB() {
        if (this.verifica) return this.question.right===1 ? 'white--text font-weight-bold' : 'black--text'
        else return this.question.right===1 ? 'green--text font-weight-bold' : parseInt(this.answered)===1 ? 'white--text font-weight-bold' : 'black--text'
      },
      rigaC() {
        if (this.verifica) return this.question.right===2 ? 'green' : this.baseColor
        else return this.question.right===2 ? this.baseColor : parseInt(this.answered)===2 ? 'red' : this.baseColor
      },
      testoC() {
        if (this.verifica) return this.question.right===2 ? 'white--text font-weight-bold' : 'black--text'
        else return this.question.right===2 ? 'green--text font-weight-bold' : parseInt(this.answered)===2 ? 'white--text font-weight-bold' : 'black--text'
      },
    },
    props: {
      question: Object,
      answered: Number
    }
  }
</script>
